import { toAbsoluteUrl } from './toAbsoluteUrl';
import { BreadcrumbJsonLdItem, BreadcrumbListJsonLd, BreadcrumbListNodeJsonLd } from './types';

const resolveBreadcrumbItem = (item: BreadcrumbJsonLdItem) => {
    if ('label' in item) {
        return {
            name: item.label,
            link: item.href ?? '',
        };
    }

    return {
        name: item.name,
        link: item.link,
    };
};

export const buildBreadcrumbListNode = (
    items: BreadcrumbJsonLdItem[],
    siteOrigin: string
): BreadcrumbListNodeJsonLd => ({
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => {
        const { name, link } = resolveBreadcrumbItem(item);

        return {
            '@type': 'ListItem',
            position: index + 1,
            name,
            item: toAbsoluteUrl(siteOrigin, link),
        };
    }),
});

export const getBreadcrumbListJsonLd = (
    items: BreadcrumbJsonLdItem[],
    siteOrigin: string
): BreadcrumbListJsonLd | null => {
    if (!siteOrigin || items.length === 0) {
        return null;
    }

    return {
        '@context': 'https://schema.org',
        ...buildBreadcrumbListNode(items, siteOrigin),
    };
};
